import { createElement } from 'react';
import './style-loading.less';
function LoadingDot(props) {
    const { text } = props;
    return (createElement("div", { className: "dot-flashing-wrapper" },
        !!text && createElement("div", { className: "text" }, text),
        createElement("div", { className: "dot-flashing" })));
}
LoadingDot.defaultProps = {
    backgroundColor: '#ADB4E2'
};
export default LoadingDot;
